import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import Auth0ProviderWithHistory from "./context/auth0-provider-with-history";
import AppLoader from "components/appLoader/AppLoader";
import { makeServer } from 'serverMock/server';

import { QueryClient, QueryClientProvider } from 'react-query';

import './i18n';

const queryClient = new QueryClient();

makeServer({ environment: "development" })

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<AppLoader />}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Auth0ProviderWithHistory>
            <App />
          </Auth0ProviderWithHistory>
        </Router>
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
